import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import {
  prepareImgixParams,
  placeholder43Url,
} from '../services/APIClient';

export const ASPECT_RATIOS = {
  SQUARE: 'SQUARE', // 1:1  <== default
  STANDARD: 'STANDARD', // 4:3
  STANDARD_HORIZONTAL: 'STANDARD_HORIZONTAL', // 16:9
};

const Base = styled.div`
  background-position: center;
  background-size: cover;
  width: 100%;
  overflow: hidden;
`;

const Placeholder = styled(Base)`
  position: relative;
  height: 0;

  && {
    padding-top: ${(props) => {
    if (props.aspectRatio === ASPECT_RATIOS.SQUARE) {
      return '100%';
    } if (props.aspectRatio === ASPECT_RATIOS.STANDARD) {
      return '75%';
    } if (props.aspectRatio === ASPECT_RATIOS.STANDARD_HORIZONTAL) {
      return '56%';
    }
    return 'initial';
  }};
  }
`;

const Image = styled(Base)`
  position: absolute;
  height: 100%;
  top: 0;
`;

const ImageOverPlaceholder = ({
  image,
  placeholder,
  className,
  aspectRatio,
  rounded,
  href,
  target,
  onClick,
  disableLazyLoading,
  borderRadius,
}) => {
  const imageUrl = image.width && image.height && image.url
    ? prepareImgixParams(image.url, { w: image.width, h: image.height, auto: 'format,compress' })
    : placeholder;

  const Result = (
    <Placeholder
      aspectRatio={aspectRatio}
      className={classnames(
        { [className]: className },
        { rounded },
      )}
      style={{
        backgroundImage: `url(${placeholder})`,
        borderRadius,
      }}
    >
      {disableLazyLoading
        ? <Image style={{ backgroundImage: `url(${imageUrl})` }} />
        : <Image className="lazyload" data-bg={imageUrl} />}
    </Placeholder>
  );
  if (href || onClick) {
    return (
      <a href={href} onClick={onClick} target={target}>{Result}</a>
    );
  }
  return Result;
};

ImageOverPlaceholder.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  placeholder: PropTypes.string,
  rounded: PropTypes.bool,
  aspectRatio: PropTypes.oneOf(Object.values(ASPECT_RATIOS)),
  className: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  disableLazyLoading: PropTypes.bool,
  borderRadius: PropTypes.string,
};
ImageOverPlaceholder.defaultProps = {
  image: {
    url: '',
    width: 0,
    height: 0,
  },
  placeholder: placeholder43Url,
  rounded: false,
  aspectRatio: 'square',
  className: '',
  href: null,
  target: '_blank',
  onClick: null,
  disableLazyLoading: false,
  borderRadius: 'unset',
};

export default ImageOverPlaceholder;
